import { Box, SystemProps } from '@storyofams/react-ui';
import { useRouter } from 'next/router';
import { css, useTheme } from 'styled-components';
import { Button, Heading, FixedRatio } from '~components';
import { ProductFullFragmentFragment } from '~lib/shopify/sdk';
import { Image } from '../common/Image';
import { ImageWrapper } from './ProductCard';

interface ProductCompactCardProps extends SystemProps {
  product: Pick<
    ProductFullFragmentFragment,
    'title' | 'images' | 'handle' | 'id' | 'description' | 'tags'
  > & {
    variants: { edges: { node: { id: string; availableForSale: boolean } }[] };
  };
  index: number;
}

export const ProductCompactCard = ({
  product,
  bg,
  index,
}: ProductCompactCardProps) => {
  const theme = useTheme();
  const router = useRouter();

  const getTitleString = (title, index) => {
    const bg = index !== 0 && index % 2 === 0 ? 'primary' : 'white';

    if (title?.length <= 20) {
      return (
        <Box
          css={css({
            span: {
              color: theme.colors.grey900,
              fontFamily: theme.fonts.heading,
              backgroundColor: theme.colors[bg],
            },
          })}
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          maxWidth="calc(100% - 16px)"
          width="max-content"
          fontSize={[14, 35]}
        >
          <span>{title}</span>
        </Box>
      );
    }
    const titleArray = title.split(' ');
    const firstHalf = titleArray.slice(0, titleArray.length / 2);
    const secondHalf = titleArray.slice(
      titleArray.length / 2,
      titleArray.length,
    );

    return (
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        maxWidth="calc(100% - 32px)"
      >
        <Heading
          variant="brandL"
          as="h2"
          fontSize={[14, 35]}
          bg={bg}
          width="max-content"
          mb={[0.5, 1]}
        >
          {firstHalf.join(' ')}
        </Heading>
        <Heading
          variant="brandL"
          as="h2"
          fontSize={[14, 35]}
          bg={bg}
          width="max-content"
          mb={0}
          ml={1}
        >
          {secondHalf.join(' ')}
        </Heading>
      </Box>
    );
  };

  return (
    <Button
      to={
        product?.tags?.includes('is_box')
          ? `/theme-boxes/${product?.handle}`
          : `/meals/${product?.handle}${
              router?.query?.ordering ? '?ordering=true' : ''
            }`
      }
      variant="unstyled"
      display="flex"
      flexDirection="column"
      width="100%"
      height="100%"
      overflow="hidden"
      p={[0, 0]}
      bg={bg}
    >
      <FixedRatio mb={0}>
        <ImageWrapper position="relative" p={bg && [1, 4]}>
          <Image
            height="100%"
            width="100%"
            layout="fill"
            objectFit="contain"
            quality={100}
            src={product?.images?.edges?.[0]?.node?.url}
          />
        </ImageWrapper>
      </FixedRatio>
      {getTitleString(product?.title, index)}
    </Button>
  );
};
